import { CommonModule } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IftaLabelModule } from 'primeng/iftalabel';
import { ImageModule } from 'primeng/image';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { GCPImage, ImageCategoryPath, OrderDetails } from '../../../constants';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { FirebaseStorageService } from '../../../services/firebase.storage.service';
import { DocumentReference } from '@angular/fire/firestore';
import { UtilityService } from '../../../services/utility.service';
import { MessageModule } from 'primeng/message';

@Component({
    selector: 'app-pre-delivery-complete-tasks',
    imports: [
        AccordionModule,
        CommonModule,
        ButtonModule,
        CardModule,
        FormsModule,
        IftaLabelModule,
        InputTextModule,
        InputNumberModule,
        FileUploadModule,
        ImageModule,
        FloatLabelModule,
        SelectModule,
        MessageModule
    ],
    templateUrl: './pre-delivery-complete-tasks.component.html',
    styleUrl: './pre-delivery-complete-tasks.component.scss',
    host: {
        class: 'app-pre-delivery-complete-tasks'
    },
    encapsulation: ViewEncapsulation.None
})
export class PreDeliveryCompleteTasksComponent {
  dynamicDialogRef = inject(DynamicDialogRef);
  dynamicDialogConfig = inject(DynamicDialogConfig);
  firebaseStorageService = inject(FirebaseStorageService);
  firebaseFirestoreService = inject(FirebaseFirestoreService);
  utilityService = inject(UtilityService);
  order: OrderDetails = {} as OrderDetails;
  images: GCPImage[] = [];
  constructor() {
    this.order = this.dynamicDialogConfig.data;

    this.firebaseFirestoreService.subscribeToOrderDetails(this.order.orderDocumentRef as DocumentReference, {
      next: (documentSnapshot) => {
        const orderDetails = documentSnapshot.data() as OrderDetails;
        this.order = {
          ...orderDetails,
          orderId: documentSnapshot.id,
          orderDocumentRef: documentSnapshot.ref
        }
        this.images = orderDetails.proofOfDeliveryImages || [];
      },
      complete: () => {},
      error: () => {}
    });
  }

  async uploadProofOfDeliveryImage({files}: {files: Array<File>}, fileupload: FileUpload) {
    for(let i = 0; i < files.length; i++) {
      const data = await this.firebaseStorageService.uploadImage(files[i], ImageCategoryPath.ProofOfDelivery);
      if(data) {
        this.images.push(data);
      }
    }
    fileupload.clear();
    await this.firebaseFirestoreService.updateOrderDetails(this.order.orderDocumentRef as DocumentReference, {proofOfDeliveryImages: this.images});
  }

  async deleteImage(index: number) {
    const data = await this.firebaseStorageService.deleteImage(this.images[index]);
    if(data) {
      this.images.splice(index, 1);
      await this.firebaseFirestoreService.updateOrderDetails(this.order.orderDocumentRef as DocumentReference, {proofOfDeliveryImages: this.images});
    }
  }

  close() {
    this.dynamicDialogRef.close(this.images.length > 0);
  }
}
